import { FOfferType } from '../../../../utils/category';

export const TARGET_OFFER_TYPE = FOfferType.FlatOld | FOfferType.Bed | FOfferType.Room | FOfferType.FlatShared;
